import {VideoPlayer} from '../parts/video-player'
import {followMouse} from '../parts/mouse-follow'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {gsap} from 'gsap'
import {breakpointUp} from '../utils/breakpoints'

gsap.registerPlugin(ScrollTrigger)

function initBlock() {

  if (!($('.block-index-hero')).length) {
    return false
  }
  // add video block container class
  if ($('.block-index-hero .top-video').length) {
    const topVideoPlayer = new VideoPlayer('.block-index-hero .top-video')
  }
  if ($('.block-index-hero .small-video').length) {
    const smallVideoPlayer = new VideoPlayer('.block-index-hero .small-video')
  }

  let scrollValue = '16px'
  let startValue = 'top+=30% top+=20%'

  if (breakpointUp('lg')) {
    scrollValue = '5rem';
  } else if (breakpointUp('sm')) {
    scrollValue = '32px'
    startValue = 'top+=30% top+=20%'
  }


  // ScrollTrigger small animation
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: '#smooth-wrapper',
      // markers: true,
      scrub: true,
      start: 'top top',

      end: 'bottom top+=10%',
    }
  })

  tl.fromTo('.block-index-hero .top-video-scroll-animation .left-element', {width: 0}, {
    width: scrollValue,
    duration: 1
  }, 0)
  tl.fromTo('.block-index-hero .top-video-scroll-animation .right-element', {width: 0}, {
    width: scrollValue,
    duration: 1
  }, 0)
  tl.fromTo('.block-index-hero .top-video-scroll-animation .bottom-element', {height: 0}, {
    height: scrollValue,
    duration: 1
  }, 0)


  if (!breakpointUp('lg')) {
    return false
  }

  followMouse()

}

function openHeroVideo() {

  if (!($('.block-index-hero')).length) {
    return false
  }

  $('.block-index-hero .js-open-video').click()

}

initBlock()

export {openHeroVideo}
